import * as React from 'react';
import { useEffect, useState } from 'react';
import { Autosuggest } from '@amzn/awsui-components-react-v3';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../reducers';
import { fetchItems } from '../../reducers/ItemsSlice';

interface ItemAutoSuggestProps {
  onFocus?: () => void;
  onSelect?: (selectedId: string) => void;
}

export const ItemAutoSuggest = (props: ItemAutoSuggestProps) => {
  const [value, setValue] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const dispatch = useDispatch();

  // Get items from Redux store with strong typing
  const itemsState = useSelector((state: RootState) => state.itemsObj);
  const { items, status, error } = itemsState;

  // Ensure items are loaded when component mounts
  useEffect(() => {
    // If items haven't been loaded yet, trigger the fetch
    if (status === 'idle') {
      dispatch(fetchItems());
    }
  }, [dispatch, status]);

  // Determine status type for Autosuggest component
  const getStatusType = () => {
    if (status === 'idle') return 'loading';
    if (status === 'loading') return 'loading';
    if (status === 'failed') return 'error';
    return 'finished';
  };

  // Get appropriate loading text based on state
  const getLoadingText = () => {
    if (status === 'idle') return 'Initializing items...';
    if (status === 'loading') return 'Fetching Items';
    return 'Loading...';
  };

  useEffect(() => {
    if (items && value) {
      const searchValue = value.toLowerCase();
      setFilteredItems(items.filter((item) => {
        return item.ItemFullName.toLowerCase().includes(searchValue)
          || item.CodeName.toLowerCase().includes(searchValue)
          || item.Pm.toLowerCase().includes(searchValue)
          || item.BusinessLineAttorney.toLowerCase().includes(searchValue)
          || item.OtherContributors.find((contact) => contact.Alias.toLowerCase().includes(searchValue));
      }));
    } else {
      setFilteredItems([]);
    }
  }, [value, items]);

  return <>
    <Autosuggest
      placeholder={"Search"}
      empty="No services found, start typing to search for a service"
      statusType={getStatusType()}
      errorText={"Error fetching Items, try again"}
      loadingText={getLoadingText()}
      options={filteredItems.map((item) => {
        return { value: item.ItemFullName + ' (' + item.CodeName + ')' }
      })}
      value={value}
      enteredTextLabel={() => value}
      filteringType="manual"
      onFocus={() => {
        if (props.onFocus) {
          props.onFocus();
        }
      }}
      onChange={(event) => {
        setValue(event.detail.value.toLowerCase())
      }}
      onSelect={(event) => {
        let codeNameFromDisplay = event.detail.value.split(' (')[1].split(')')[0];
        let selectedItem = items.find(item => {
          return item.CodeName === codeNameFromDisplay;
        });
        
        if (selectedItem) {
          setValue("");
          if (props.onSelect) {
            props.onSelect(selectedItem.Id);
          }
        }
      }}
    ></Autosuggest>
  </>
}
